import { request as __request } from '../core/request.js';
export class BundleMixesService {
    /**
     * List all bundle mixes
     * Returns bundle mixes.
     *
     * Bundle mixes are predefined bundle selections, for example following Oxford Offsetting Principles.
     * Bundle selection for a particular Bundle mix may change over time.
     *
     * @returns BundleMix The response returns the bundle mixes
     */
    listAllBundleMixes() {
        return __request(this.client, this.config, {
            method: 'GET',
            url: '/bundle-mixes',
            errors: {
                401: `Unauthorized. The API Key is invalid or disabled.`,
                429: `Rate limit exceeded`,
            },
        });
    }
}
//# sourceMappingURL=BundleMixesService.js.map